// Theme switching (light default for a low-key, work-friendly look).
// Persisted in localStorage; a small corner toggle flips light/dark.

type Theme = 'light' | 'dark';
const KEY = 'listen-up-theme';

function getTheme(): Theme {
  return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
}

function applyTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t);
}

let toggleBtn: HTMLButtonElement | null = null;

function updateToggle(t: Theme): void {
  if (!toggleBtn) return;
  // Half-moon glyph; deliberately unobtrusive.
  toggleBtn.textContent = t === 'light' ? '◐' : '◑';
  toggleBtn.title = t === 'light' ? 'Switch to dark' : 'Switch to light';
}

export function initTheme(): void {
  const t = getTheme();
  applyTheme(t);

  toggleBtn = document.createElement('button');
  toggleBtn.className = 'theme-toggle';
  toggleBtn.setAttribute('aria-label', 'Toggle theme');
  toggleBtn.addEventListener('click', () => {
    const next: Theme = getTheme() === 'light' ? 'dark' : 'light';
    localStorage.setItem(KEY, next);
    applyTheme(next);
    updateToggle(next);
  });
  document.body.appendChild(toggleBtn);
  updateToggle(t);
}
